'use client';
import Image from 'next/image';
import Link from 'next/link';
import { Inner } from '@/widget/container/ui/Inner';
import { NAV } from '@/shared/utils/const';
import { useSession } from '@/app/providers';
import { useNoticeData } from '@/features/notice/hook/useNoticeData';

export const HeaderMobile = () => {
  const session = useSession()
  const { unreadCnt } = useNoticeData(null)
  return (
    <header>
      <Inner type="mobile" className="flex items-center justify-between h-[50px] bg-mob-color">
        <h1 className="w-[138px] h-[24px]">
          <Link href="/v2" className="inline-flex w-[138px] h-[24px] align-top">
            <Image
              width={138}
              height={24}
              src={NAV.mo.logo}
              unoptimized
              className="align-top"
              alt="logo" />
          </Link>
        </h1>
        {
          session?.NewAuthToken && (
            <Link href="/v2/notice" className="relative flex flex-shrink-0 items-end w-[18px] h-[18px]">
              <Image src={NAV.mo.notice} width={18} height={18} alt="notice" unoptimized />
              {
                Number(unreadCnt) > 0 && (
                  <span className="alarm-count">
                    {Number(unreadCnt) > 99 ? '+99' : unreadCnt}
                  </span>
                )
              }
            </Link>

          )
        }
      </Inner>
    </header>
  );
};
